<template>
	<EMCoreTemplate category="System" identity="systemLogs" entity="osm_product"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/SystemManagement/containers/SystemLogs.vue